<template>
  <div id="forgotPasswordPage">
    <flash-message size="is-size-6"></flash-message>
    <h2 v-if="!success" class="has-text-weight-bold has-text-centered is-size-4">Forgot your password?</h2>
    <p v-if="!success" class="has-text-centered is-size-6 disclaimer">Enter your email address and we'll send you a link to reset your password:</p>
    <form novalidate v-on:submit.prevent="submitRequest">
      <p v-if="!success" class="control">
        <input tabindex="1" :disabled="sending" class="input hp-input" type="email" name="email" placeholder="Email address or username" v-model="form.email"/>
      </p>
      <p v-if="!success" class="control">
        <button
          tabindex="3"
          :disabled="canSubmit"
          @click.prevent="submitRequest"
          type="submit"
          :class="[{ 'is-loading': sending}, 'button', 'hp-btn-primary', 'is-fullwidth']">SEND PASSWORD RESET LINK
        </button>
      </p>
      <p class="control has-text-centered has-text-weight-bold is-size-7">
        <router-link to="/login" class="has-text-weight-normal link--v2">Sign in now</router-link>
      </p>
    </form>
  </div>
</template>
<script>
import ApiResource from '@/api/ApiResource'
import FlashMessage from '@/components/FlashMessage'

export default {
  name: 'ForgotPassword',
  metaInfo: {
    title: 'Hellopeter - Forgot Password'
  },
  components: {
    FlashMessage
  },
  mounted () {
    this.$gtm.trackEvent({
      event: 'pageLoad',
      virtualPageUrl: this.$router.currentRoute.path,
      virtualPageTitle: 'Forgot Password'
    })
    window.prerenderReady = true
  },
  data () {
    return {
      sending: false,
      form: new ApiResource({
        email: ''
      }),
      success: false
    }
  },
  computed: {
    canSubmit () {
      return false
    }
  },
  methods: {
    submitRequest () {
      this.sending = true
      this.form.send(`/consumer/user/forgot-password`)
        .then(() => {
          this.sending = false
          this.success = true
          flash('Your password reset link has been sent.', 'is-success', true)
        })
        .catch(() => {
          this.form.errors.errors = this.form.errors.errors.errors
          let msg = this.form.errors.getDefaultErrorMessage()
          flash(msg, 'is-danger')
          this.sending = false
        })
    }
  }
}
</script>
<style lang="scss">
h2 {
  margin-bottom: 1rem;
  margin-top: 1rem;
}

#forgotPasswordPage .control:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/auth/ForgotPassword.vue